// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__IWWdI","loader":"loader_loader__CdasA","load":"loader_load__d+D6D"};